import { useGetAvailableTimeslotsForBookingSessionQuery } from '@pm/graphql';
import { parseISO } from 'date-fns';
export const useAppointmentTimeSlots = (
  bookingSessionId: string,
  date: Date,
  options?: { skip?: boolean },
) => {
  const {
    data: availableTimeslotsData,
    loading,
    error,
  } = useGetAvailableTimeslotsForBookingSessionQuery({
    variables: {
      bookingSessionId,
      bookingDate: date.toISOString(),
    },
    fetchPolicy: 'cache-and-network',
    skip: options?.skip,
  });

  const availableAppointmentTimes =
    availableTimeslotsData?.availableTimeSlotsForBookingSession ?? [];

  const availableTimeSlots = availableAppointmentTimes.map(
    ({ time, providerId }) => ({
      time: parseISO(time),
      providerId: providerId ? String(providerId) : undefined,
    }),
  );

  return {
    availableTimeSlots,
    loading,
    error,
  } as const;
};
